import React, { useEffect, useState } from "react";
import { Bounce, toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { IoIosArrowRoundBack } from "react-icons/io";
import { useAuth } from "../../../../context/AuthContext";
import classes from "./AddDocumentsRecords.module.css";
import QuestionCard from "../../../ui/QuestionCard/QuestionCard";
import QuestionBox from "../../../ui/QuestionBox/QuestionBox";
import CommonFooter from "../../../CommonFooter/CommonFooter";
import ScoredInputRow from "../../../ui/ScoredInputRow/ScoredInputRow";
import { env } from "../../../../constants/env";
import QuestionSection from "../../../ui/QuestionSection/QuestionSection";
import { useCertification } from "../../../../hooks/useCertification";

const questionSets = [
  {
    render: (onAnswerChange, answers, editable) => (
      <>
        <QuestionSection
          number="1.1"
          title="Legal Entity"
          questions={[
            {
              content:
                "Does the laboratory have documentation stating its legal identity?...",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="1.2"
          title="Laboratory management system policies and objectives"
          questions={[
            {
              content:
                "Quality policy statement that includes scope of service, standard of service, measurable objectives of the laboratory management system, and management commitment to compliance to the implementation of the policies;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Documented policies of the laboratory management system that meet the requirements of ISO15189:2022 and the requirements of the accreditation bodies (where relevant);",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Description of the laboratory management system and the structure of its documentation;",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Reference to supporting procedures (e.g., SOPs), including managerial and technical procedures;",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Description of the roles and responsibilities of the laboratory director (however named) and other key personnel responsible for ensuring compliance with the established organizational structure (organogram)",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Record of review and approval of this document (quality manual or equivalent) by authorized personnel;",
              number: "f",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Records to show that relevant sections of this document were communicated to and understood by the relevant personnel (internal and external persons).",
              number: "g",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="1.3"
          title="Document and Information Control System"
          questions={[
            {
              content:
                "Has the laboratory management established and implemented a document control system to control all documents and information from internal and external sources?.",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="1.4"
          title="Document and Records"
          questions={[
            {
              content:
                "Are there records detailing all documents of the laboratory management system and indicating their editions and distribution?",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="1.5"
          title="Laboratory Management System Documentation"
          questions={[
            {
              content:
                "Has the laboratory management established, documented and maintained objectives and policies to fulfil the requirements of ISO 15189:2022 standards?",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Are these objectives and policies acknowledged and implemented at all levels of the laboratory?",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="1.6"
          title="Quality Document Accessibility"
          questions={[
            {
              content:
                "Are quality documents (paper based and/or electronic copies) easily accessible, available and written in a language commonly understood and communicated to all relevant personnel?",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="1.7"
          title="Document Control Record"
          questions={[
            {
              content:
                "Do all quality documents have a record to reflect when it was approved for use, its review and revision history, its version, its location and when it was discontinued?",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="1.8"
          title="Discontinued Quality Documents"
          questions={[
            {
              content:
                "Are invalid or discontinued quality documents identified, clearly marked, removed from use and one copy retained for reference purposes?",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="1.9"
          title="Data Files"
          questions={[
            {
              content:
                "Are test results, technical and quality records archived for a specified period in accordance with the requirements of Section 9 of this checklist?",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="1.10"
          title="Archived Patient Results Accessibility"
          questions={[
            {
              content:
                "Are test results, technical and quality records archived for a specified period in accordance with the requirements of Section 9 of this checklist?",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />
      </>
    ),
  },
];

const AddDocumentsRecords = () => {
  const navigate = useNavigate();
  const { questionnaireId } = useParams();
  const { user } = useAuth();

  const [currentSet, setCurrentSet] = useState(0);

  const {
    formData: answers,
    handleChange: handleAnswerChange,
    handleDone,
    editMode,
    loading,
    isFetching,
  } = useCertification(
    "Documents & Records", // section
    {},                    // initialAnswers
    questionnaireId        // questionnaireId (optional)
  );

  console.log("Answers:", answers);
  const handleNext = () => {
    if (currentSet < questionSets.length - 1) setCurrentSet(currentSet + 1);
  };

  const handlePrevious = () => {
    if (currentSet > 0) setCurrentSet(currentSet - 1);
  };

  return (
    <div className={`${classes.wrapper} ${!editMode ? classes.fromParams : ""}`}>
      <div
        className="d-flex align-items-center gap-2 mb-4"
        onClick={() => navigate(-1)}
        role="button"
      >
        <IoIosArrowRoundBack size={35} />
        <h2 className="m-0">
          Section 01: Documents & Records {questionnaireId && "(Editing)"}
        </h2>
      </div>

      {isFetching || loading ? (
        <p>Loading...</p>
      ) : (
        <>
          {questionSets[currentSet].render(handleAnswerChange, answers, editMode)}

          {editMode && (
            <CommonFooter
              handlePrevious={handlePrevious}
              handleCancel={() => navigate(-1)}
              handleNext={handleNext}
              handleDone={handleDone}
              questionSets={questionSets}
              currentSet={currentSet}
              cancelText="Cancel"
              doneText={questionnaireId ? "Update Assessment" : "Submit Assessment"}
            />
          )}
        </>
      )}
    </div>
  );
};

export default AddDocumentsRecords;
